  export default {
    s3: {
      REGION: process.env.REACT_APP_S3_REGION,
      BUCKET: process.env.REACT_APP_S3_BUCKET
    },
    apiGateway: {
      REGION: process.env.REACT_APP_API_REGION,
      URL: process.env.REACT_APP_API_GATEWAY
    },
    cognito: {
      REGION: process.env.REACT_APP_COGNITO_REGION,
      USER_POOL_ID: process.env.REACT_APP_COGNITO_USER_POOL_ID,
      APP_CLIENT_ID: process.env.REACT_APP_CLIENT_ID,
      IDENTITY_POOL_ID: process.env.REACT_APP_IDENTITY_POOL_ID
    },
    MAX_ATTACHMENT_SIZE: process.env.REACT_APP_MAX_ATTACHMENT_SIZE,
    STRIPE_CONNECT_API: process.env.REACT_APP_STRIPE_CONNECT_API,
    STRIPE_REDIRECT_URL: process.env.REACT_APP_STRIPE_REDIRECT_URL,
    ADMIN_PROFILE: "A",
    SUPER_ADMIN_PROFILE: "S",
    REPORTS_USER_PROFILE: "R"
  };